module.exports = __webpack_public_path__ + "img/passportCheck.30be5587.png";